export const PLOT_METADATA = {
  annotations: [
    {
      text: '',
      font: {
        size: 10,
      },
      showarrow: false,
    },
  ],
  margin: {
    l: 0,
    r: 0,
    b: 0,
    t: 0,
    pad: 0,
  },
  autosize: false,
  height: 100,
  width: 100,
  paper_bgcolor: 'rgba(0,0,0,0)',
  plot_bgcolor: 'rgba(0,0,0,0)',
  showlegend: false,
};

export const VALUES_METADATA = [
  {
    values: [],
    labels: ['Approved', 'Pending', 'Denied'],
    hoverinfo: 'label+percent',
    hole: 0.65,
    type: 'pie',
    textinfo: 'none',
  },
];

export const OPTIONS = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  weekday: 'long',
};

export const getLeaveStatus = (status) => {
  if (status === 'APPROVED') return 'Approved';
  if (status === 'PENDING') return 'Pending';
  if (status === 'REJECTED') return 'Rejected';
};
